/* PJC v14 — Vidéo de Noël générée : chronologie des scènes, neige, pause hors écran, export .webm.
   Scènes : intro (1.4 s) → products (cartes une à une, 0.65 s chacune, +1.4 s) → headline (1.6 s) → cta (pause réglable) → out (0.9 s) → boucle.
   Respecte prefers-reduced-motion (tout est affiché fixe, aucune chronologie). */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(root) {
    if (root.dataset.nvReady) return;
    root.dataset.nvReady = '1';

    var stage = root.querySelector('[data-nv-stage]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.pjc-nv__card'));
    var progress = root.querySelector('[data-nv-progress]');
    var toggle = root.querySelector('[data-nv-toggle]');
    var canvas = root.querySelector('[data-nv-snow]');
    var hold = Math.max(2, Number(root.dataset.hold) || 4) * 1000;
    var autoplay = root.dataset.autoplay !== 'false';

    if (reduce.matches) {
      stage.classList.add('is-static');
      stage.dataset.scene = 'cta';
      return;
    }

    /* ---- Chronologie ---- */
    var steps = [];
    var t = 0;
    steps.push({ at: 0, run: function () { stage.dataset.scene = 'intro'; cards.forEach(function (c) { c.classList.remove('is-in'); }); } });
    t += 1400;
    steps.push({ at: t, run: function () { stage.dataset.scene = 'products'; } });
    cards.forEach(function (c, i) {
      t += i === 0 ? 150 : 650;
      steps.push({ at: t, run: function () { c.classList.add('is-in'); } });
    });
    t += 1400;
    steps.push({ at: t, run: function () { stage.dataset.scene = 'headline'; } });
    t += 1600;
    steps.push({ at: t, run: function () { stage.dataset.scene = 'cta'; } });
    t += hold;
    steps.push({ at: t, run: function () { stage.dataset.scene = 'out'; } });
    var total = t + 900;
    root.dataset.cycle = String(total);

    var start = 0;
    var paused = !autoplay;
    var visible = true;
    var raf = 0;
    var next = 0;
    var onCycleEnd = null;

    function tick(now) {
      if (!start) start = now;
      var el = now - start;
      while (next < steps.length && steps[next].at <= el) {
        steps[next].run();
        next++;
      }
      if (progress) progress.style.setProperty('--p', Math.min(1, el / total).toFixed(3));
      if (el >= total) {
        if (onCycleEnd) { var cb = onCycleEnd; onCycleEnd = null; cb(); }
        start = now;
        next = 0;
      }
      if (!paused && visible) raf = requestAnimationFrame(tick);
      else raf = 0;
    }

    function play() {
      if (raf) return;
      start = 0;
      next = 0;
      raf = requestAnimationFrame(tick);
    }

    function stop() {
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
    }

    function restart() {
      stop();
      start = 0;
      next = 0;
      steps[0].run();
      raf = requestAnimationFrame(tick);
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        paused = !paused;
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        toggle.setAttribute('aria-label', paused ? 'Relancer l’animation' : 'Mettre en pause l’animation');
        if (paused) { stop(); } else { restart(); }
      });
      if (!autoplay) toggle.setAttribute('aria-pressed', 'true');
    }

    /* ---- Neige (canvas léger) ---- */
    var flakes = [];
    var ctx = canvas && canvas.getContext('2d');
    var snowRaf = 0;

    function sizeCanvas() {
      if (!canvas) return;
      var r = stage.getBoundingClientRect();
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      canvas.width = Math.round(r.width * dpr);
      canvas.height = Math.round(r.height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.max(40, Math.min(120, r.width / 10)));
      flakes = [];
      for (var i = 0; i < n; i++) {
        flakes.push({ x: Math.random() * r.width, y: Math.random() * r.height, r: 1 + Math.random() * 2.4, s: 0.4 + Math.random() * 0.9, w: Math.random() * 6.28 });
      }
    }

    function snow() {
      if (!ctx) return;
      var w = canvas.width / (Math.min(2, window.devicePixelRatio || 1));
      var h = canvas.height / (Math.min(2, window.devicePixelRatio || 1));
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = 'rgba(255,248,237,0.9)';
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.y += f.s;
        f.w += 0.01;
        f.x += Math.sin(f.w) * 0.3;
        if (f.y > h + 4) { f.y = -4; f.x = Math.random() * w; }
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, 6.28);
        ctx.fill();
      }
      snowRaf = visible ? requestAnimationFrame(snow) : 0;
    }

    /* ---- Visibilité : tout s'arrête hors écran ou onglet caché ---- */
    function setVisible(v) {
      visible = v;
      if (v) {
        if (!paused && !raf) raf = requestAnimationFrame(tick);
        if (ctx && !snowRaf) snowRaf = requestAnimationFrame(snow);
      } else {
        stop();
        if (snowRaf) cancelAnimationFrame(snowRaf);
        snowRaf = 0;
      }
    }

    var inView = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        setVisible(inView && !document.hidden);
      }, { threshold: 0.15 }).observe(stage);
    }
    document.addEventListener('visibilitychange', function () {
      setVisible(inView && !document.hidden);
    });

    var rt = 0;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(sizeCanvas, 150);
    });

    sizeCanvas();
    if (ctx) snowRaf = requestAnimationFrame(snow);
    if (autoplay) play(); else { steps[0].run(); }

    /* ---- Outils : plein écran + enregistrement d'un cycle (.webm) ---- */
    var fs = root.querySelector('[data-nv-fullscreen]');
    var rec = root.querySelector('[data-nv-record]');
    var status = root.querySelector('[data-nv-status]');

    if (fs) {
      fs.addEventListener('click', function () {
        if (document.fullscreenElement) document.exitFullscreen();
        else if (stage.requestFullscreen) stage.requestFullscreen();
        setTimeout(sizeCanvas, 300);
      });
    }

    if (rec) {
      rec.addEventListener('click', async function () {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia || !window.MediaRecorder) {
          if (status) status.textContent = 'Votre navigateur ne permet pas l’enregistrement ; utilisez Chrome ou Edge sur ordinateur.';
          return;
        }
        var stream;
        try {
          stream = await navigator.mediaDevices.getDisplayMedia({
            video: { frameRate: 30 },
            audio: false,
            preferCurrentTab: true,
            selfBrowserSurface: 'include',
            surfaceSwitching: 'exclude'
          });
        } catch (e) {
          if (status) status.textContent = 'Enregistrement annulé.';
          return;
        }
        var mime = ['video/webm;codecs=vp9', 'video/webm;codecs=vp8', 'video/webm'].filter(function (m) { return MediaRecorder.isTypeSupported(m); })[0] || '';
        var mr = new MediaRecorder(stream, mime ? { mimeType: mime, videoBitsPerSecond: 8000000 } : undefined);
        var chunks = [];
        mr.ondataavailable = function (e) { if (e.data && e.data.size) chunks.push(e.data); };
        mr.onstop = function () {
          stream.getTracks().forEach(function (tr) { tr.stop(); });
          var blob = new Blob(chunks, { type: 'video/webm' });
          var a = document.createElement('a');
          var name = 'pyjaclub-noel-' + (root.dataset.nvName || root.id) + '-' + new Date().toISOString().slice(0, 10) + '.webm';
          a.href = URL.createObjectURL(blob);
          a.download = name;
          document.body.appendChild(a);
          a.click();
          setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
          rec.disabled = false;
          if (status) status.textContent = 'Vidéo téléchargée : ' + name + '. Pour un fichier MP4, convertissez le .webm (par ex. avec HandBrake ou un convertisseur en ligne).';
        };
        rec.disabled = true;
        if (status) status.textContent = 'Enregistrement d’un cycle complet (' + Math.round(total / 1000) + ' s)…';
        paused = false;
        if (toggle) toggle.setAttribute('aria-pressed', 'false');
        onCycleEnd = function () { if (mr.state !== 'inactive') mr.stop(); };
        mr.start(250);
        restart();
      });
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pjc-nv]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
